import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from "../../components/ui/menubar";
import { ThemeMenu } from "@/features/theme/ThemeMenu";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/features/auth/useAuth";
import NotificationDropdown from "@/features/notifications/NotificationDropdown";
import { NotificationSocket } from "@/features/notifications/NotificationSocket";

export function Header({ className }: { className?: string }) {
  const auth = useAuth();
  const user = auth.getUser();

  if (!user) {
    console.error("User is not found.");
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate();

  const additonalClasses = className ? ` ${className}` : "";

  function handleLogout() {
    auth.logout();
  }

  // function for handle navigate to profile
  function handleProfile() {
    // navigate to /profile using react-router
    navigate("/profile");
  }

  return (
    <header
      className={
        "fixed top-0 z-10 my-auto flex w-full items-center justify-end gap-x-2 bg-white px-8 dark:bg-neutral-800 print:hidden" +
        additonalClasses
      }
    >
      <h1 className="sr-only">Link Net Interval</h1>
      <Menubar className="border-none">
        <MenubarMenu>
          <MenubarTrigger aria-label="Menu akun">
            Hi, {user.username}
          </MenubarTrigger>
          <MenubarContent align="end">
            <MenubarItem onClick={handleProfile}>Profile</MenubarItem>
            <MenubarItem onClick={handleLogout}>Log out</MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
      <NotificationDropdown />
      <NotificationSocket />
      <ThemeMenu />
    </header>
  );
}
